export default function PageJsonLd() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "BreadcrumbList",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "Главная", "item": { "@id": "https://business-training.by/", "name": "Главная" } },
          { "@type": "ListItem", "position": 2, "name": "Менеджмент и лидерство", "item": { "@id": "https://business-training.by/menedzhment-i-liderstvo", "name": "Менеджмент и лидерство" } }
        ]
      },
      {
        "@type": "Service",
        "name": "Обучение менеджменту и лидерству",
        "description": "Обучение руководителей и менеджеров: лидерство, делегирование, постановка задач, обратная связь, мотивация, переговоры и управление командой. Корпоративные программы в Минске и Беларуси.",
        "provider": {
          "@type": "Person",
          "name": "Алексей Сивко",
          "jobTitle": "Бизнес-тренер, консультант по продажам и управлению, фасилитатор, сертифицированный коуч ICU",
          "url": "https://business-training.by/o-trenere",
          "sameAs": ["https://www.linkedin.com/in/alekseysivko", "https://t.me/a_sivko"]
        },
        "areaServed": [
          { "@type": "Country", "name": "Беларусь" },
          { "@type": "Country", "name": "Россия" },
          { "@type": "Country", "name": "Казахстан" },
          { "@type": "Country", "name": "Израиль" }
        ],
        "serviceType": "обучение руководителей, менеджмент и лидерство",
        "url": "https://business-training.by/menedzhment-i-liderstvo",
        "offers": {
          "@type": "Offer",
          "category": "Корпоративное обучение",
          "itemOffered": {
            "@type": "Service",
            "name": "Программы развития менеджмента и лидерства",
            "description": "Корпоративные программы для руководителей и управленческих команд: лидерство, делегирование, постановка задач, обратная связь, мотивация, управление конфликтами, принятие решений, управление изменениями"
          }
        }
      },
      {
        "@type": "WebPage",
        "name": "Менеджмент и лидерство: обучение руководителей и развитие управленческих компетенций",
        "description": "Обучение руководителей и менеджеров: лидерство, делегирование, постановка задач, обратная связь, мотивация, переговоры и управление командой. Корпоративные программы в Минске и Беларуси.",
        "url": "https://business-training.by/menedzhment-i-liderstvo",
        "isPartOf": {
          "@type": "WebSite",
          "name": "Business Training",
          "url": "https://business-training.by"
        }
      },
      {
        "@type": "Person",
        "name": "Алексей Сивко",
        "jobTitle": "Бизнес-тренер",
        "description": "18+ лет практики в корпоративном обучении. 100+ корпоративных проектов, 450+ тренингов и бизнес-сессий, 4500+ участников. Средняя оценка участников — 9,09/10. Работал с компаниями Беларуси, России, Казахстана и Израиля.",
        "url": "https://business-training.by/o-trenere",
        "sameAs": ["https://www.linkedin.com/in/alekseysivko", "https://t.me/a_sivko"]
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Что включает обучение менеджменту и лидерству?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Обучение включает развитие ключевых управленческих компетенций: лидерство и влияние, постановку задач, делегирование, контроль, обратную связь, мотивацию команды, управление конфликтами, принятие решений, управленческие коммуникации, управление изменениями и развитие сотрудников. Программа адаптируется под конкретные задачи и уровень руководителей компании."
            }
          },
          {
            "@type": "Question",
            "name": "Для каких руководителей подходит обучение?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Обучение подходит для всех уровней руководителей: новых руководителей, недавно назначенных на должность; руководителей среднего звена, повышающих эффективность управления; РОПов и коммерческих руководителей; топ-менеджеров, работающих с масштабированием и изменениями; управленческих команд целиком; кадрового резерва, готовящегося к руководящим позициям."
            }
          },
          {
            "@type": "Question",
            "name": "Чем обучение руководителей отличается от обычного тренинга?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Обучение руководителей — это не просто тренинг, а системный процесс: диагностика реальных управленческих задач компании, адаптация программы под отрасль и уровень руководителей, практическая отработка на реальных кейсах, внедрение инструментов в ежедневную управленческую практику и сопровождение после обучения. Мы не читаем лекции — мы меняем управленческое поведение."
            }
          },
          {
            "@type": "Question",
            "name": "Какие управленческие навыки развиваются на тренинге?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "На тренинге развиваются: лидерство и влияние на команду, постановка задач с измеримым результатом, делегирование без микроменеджмента, контроль через систему контрольных точек, обратная связь, меняющая поведение, мотивация сотрудников, управление конфликтами, принятие решений в условиях неопределённости, эффективные коммуникации и управление изменениями."
            }
          },
          {
            "@type": "Question",
            "name": "Сколько длится обучение руководителей?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Формат и продолжительность зависят от задач компании. Корпоративный тренинг — 1-3 дня интенсивной практики. Модульная программа — несколько модулей с практикой между встречами. Управленческая программа — комплексное развитие на протяжении нескольких месяцев. Точная продолжительность определяется после диагностики потребностей."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли адаптировать программу под нашу компанию?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да, адаптация — обязательный этап. Мы не начинаем с готовой презентации. Сначала разбираемся, какие управленческие задачи действительно существуют в компании, изучаем отраслевую специфику, уровень руководителей и ожидания бизнеса. После этого программа настраивается под реальные потребности, используются кейсы и ситуации компании."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли обучать руководителей онлайн?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да, онлайн-формат доступен и эффективен. Он удобен для распределённых команд, позволяет экономить время на логистике и подходит для модульных программ с практикой между встречами. Однако для командообразующих элементов и интенсивной отработки навыков офлайн-формат даёт более высокую вовлечённость. Оптимальный вариант — blended: сочетание очных интенсивов с онлайн-сопровождением."
            }
          },
          {
            "@type": "Question",
            "name": "Подходит ли программа для новых руководителей?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да, для новых руководителей это особенно важно. Когда лучшего специалиста повышают до руководителя, он сталкивается с принципиально новой ролью: теперь он отвечает не за свой результат, а за результат команды. Программа помогает новым руководителям освоить постановку задач, делегирование, контроль, обратную связь и другие управленческие инструменты."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли проводить обучение для всей управленческой команды?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да, обучение всей управленческой команды — один из самых эффективных форматов. Когда все руководители компании проходят программу вместе, формируется единый управленческий язык, общие подходы к постановке задач, контролю и обратной связи. Это особенно важно для компаний, которые масштабируются или внедряют изменения."
            }
          },
          {
            "@type": "Question",
            "name": "Что происходит после тренинга? Можно ли добавить сопровождение?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "После тренинга при необходимости продолжается работа с командой: разбор реальных управленческих ситуаций, поддержка внедрения инструментов, ответы на вопросы участников. Сопровождение повышает вероятность того, что новые навыки закрепятся в практике, а не забудутся через несколько недель. Компания также может получить инструменты, алгоритмы и чек-листы для дальнейшего использования."
            }
          },
          {
            "@type": "Question",
            "name": "Как оценить эффективность обучения руководителей?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Эффективность оценивается на нескольких уровнях: реакция участников (удовлетворённость программой), усвоение знаний и навыков, применение инструментов в работе (изменение управленческого поведения) и влияние на бизнес-показатели. Через 1-3 месяца после обучения мы определяем, какие изменения произошли в управленческой практике: стали ли задачи ставиться понятнее, снизился ли микроменеджмент, изменилось ли качество обратной связи."
            }
          }
        ]
      }
    ]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}